import React, { useState } from "react";
import { PlusCircle, Calendar, CheckCircle, Clock, Edit } from "lucide-react";
import { toast } from "react-toastify";
import { updateMilestone } from "../../api/milestoneApi";
import MilestoneFormModal from "../programManager/MilestoneFormmodal";

const MilestoneListPanel = ({ milestones, onUpdate, projectId }) => {
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [selectedMilestone, setSelectedMilestone] = useState(null);

    const handleOpenFormModal = (milestone = null) => {
        setSelectedMilestone(milestone);
        setIsFormModalOpen(true);
    };

    const handleCloseFormModal = () => {
        setIsFormModalOpen(false);
        setSelectedMilestone(null);
        onUpdate(); // Re-fetch all data in the parent component
    };

    const handleAchieveMilestone = async (milestoneId) => {
        try {
            await updateMilestone(milestoneId, { status: "Completed" });
            toast.success("Milestone marked as achieved! 🎉");
            onUpdate(); // Trigger a data refresh
        } catch (error) {
            toast.error("Failed to update milestone status. 😢");
            console.error(error);
        }
    };

    return (
        <div className="flex flex-col h-full">
            <button
                onClick={() => handleOpenFormModal(null)}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded-lg flex items-center justify-center transition duration-300 shadow-md mb-4"
            >
                <PlusCircle size={20} className="mr-2" /> Add New KPI
            </button>

            <div className="flex-grow overflow-y-auto pr-2 space-y-3">
                {milestones.length > 0 ? (
                    milestones.map((milestone) => (
                        <div key={milestone._id} className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                            <div className="flex items-start">
                                <div className="mr-3 mt-1 text-orange-500">
                                    <Calendar size={18} />
                                </div>
                                <div className="flex-grow">
                                    <h4 className="font-semibold text-gray-800">{milestone.title}</h4>
                                    <p className="text-sm text-gray-600">
                                        Due: {new Date(milestone.dueDate).toLocaleDateString()}
                                    </p>
                                </div>
                                <div className="ml-auto flex items-center space-x-2">
                                    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                        milestone.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                        milestone.status === 'In Progress' ? 'bg-yellow-100 text-yellow-800' :
                                        'bg-gray-100 text-gray-800'
                                    }`}>
                                        {milestone.status}
                                    </span>
                                    {milestone.status !== 'Completed' && (
                                        <>
                                            <button
                                                onClick={() => handleOpenFormModal(milestone)}
                                                className="text-gray-500 hover:text-gray-700"
                                                title="Edit Milestone"
                                            >
                                                <Edit size={18} />
                                            </button>
                                            <button
                                                onClick={() => handleAchieveMilestone(milestone._id)}
                                                className="text-green-500 hover:text-green-700"
                                                title="Mark as Achieved"
                                            >
                                                <CheckCircle size={18} />
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center py-8 text-gray-500">
                        No milestones have been added for this project yet.
                    </div>
                )}
            </div>
            {isFormModalOpen && (
                <MilestoneFormModal
                    isOpen={isFormModalOpen}
                    onClose={handleCloseFormModal}
                    projectId={projectId}
                    milestone={selectedMilestone}
                    onMilestoneAdded={handleCloseFormModal}
                    onMilestoneUpdated={handleCloseFormModal}
                />
            )}
        </div>
    );
};

export default MilestoneListPanel;